// extracted by mini-css-extract-plugin
export default {"root":"AppContainer_root__DB2eG","header":"AppContainer_header__QfwOK","content":"AppContainer_content__lobs1","exit":"AppContainer_exit__680xk","title":"AppContainer_title__KIpfa"};